export const allListCategory = 'All';
export const maxMobileListToShow = 8;
